import Ticker from "./Ticker";

export default Ticker;
